import React from "react";
import {
  Layout,
  Card,
  FormLayout,
  InlineStack,
  TextField,
  Text,
} from "@shopify/polaris";

const DimensionBox = ({
  weight,
  height,
  width,
  length,
  onDimensionChange,
  editable,
}) => {
  return (
    <Layout.Section>
      <Text as="h3" variant="headingSm">
        Dimensions
      </Text>
      <br />

      <Card title="Additional Bundle Details" sectioned>
        <FormLayout>
          <InlineStack align="space-between" gap={"100"} wrap={false}>
            <TextField
              label="Weight (grams)"
              value={weight}
              placeholder="e.g. 200"
              onChange={(value) => onDimensionChange("weight", value)}
              type="number"
              disabled={!editable}
            />
            <TextField
              label="Height (cm)"
              value={height}
              placeholder="e.g. 10"
              onChange={(value) => onDimensionChange("height", value)}
              type="number"
              disabled={!editable}
            />
            <TextField
              label="Width (cm)"
              value={width}
              placeholder="e.g. 15"
              onChange={(value) => onDimensionChange("width", value)}
              type="number"
              disabled={!editable}
            />
            <TextField
              label="Length (cm)"
              value={length}
              placeholder="e.g. 20"
              onChange={(value) => onDimensionChange("length", value)}
              type="number"
              disabled={!editable}
            />
          </InlineStack>
        </FormLayout>
      </Card>
    </Layout.Section>
  );
};

export default DimensionBox;
